import type { OrganizationMembershipResponse } from '@/types';

export const isNewOrganization = (createdOn?: string) => {
  if (!createdOn) return false;
  const created = new Date(createdOn);
  if (Number.isNaN(created.getTime())) return false;
  const daysSince = Math.floor(
    (Date.now() - created.getTime()) / (1000 * 60 * 60 * 24)
  );
  return daysSince <= 7;
};

export const normalizeOrg = (org: OrganizationMembershipResponse[number]) => {
  const profile = org.client?.client_profile ?? null;

  const displayName =
    profile?.name?.trim() ||
    org.client?.name?.trim() ||
    org.client?.schema_name?.trim() ||
    'Workspace';

  const logoUrl = profile?.logo_url?.trim() || '';
  const schemaName = org.client?.schema_name?.trim() || '';

  const orgType =
    org.client?.organization_type?.trim() ||
    org.client?.tenant_type?.trim() ||
    'Workspace';

  const isCompany =
    orgType === 'Company/Business/Enterprise' ||
    orgType === 'NGO/INGO' ||
    orgType === 'City/Municipality';

  const roles = Array.isArray(org.user_roles) ? org.user_roles : [];
  const primaryRole = roles[0] || 'Member';

  const roleLabel = roles.includes('SUPER ADMIN')
    ? 'SUPER ADMIN'
    : roles.includes('SCHOOL ADMIN')
      ? isCompany
        ? 'COMPANY ADMIN'
        : 'SCHOOL ADMIN'
      : roles.includes('TEACHER')
        ? isCompany
          ? 'USER'
          : 'TEACHER'
        : primaryRole;

  // Button text
  const buttonLabel = roles.includes('SUPER ADMIN')
    ? 'Open Admin Console'
    : roles.includes('SCHOOL ADMIN')
      ? `Launch ${schemaName}  Dashboard`
      : `Open ${schemaName}  Workspace`;

  return {
    displayName,
    logoUrl,
    schemaName,
    orgType,
    roles,
    primaryRole,
    roleLabel,
    buttonLabel,
    created_on: org.client?.created_on,
  };
};
